/* Nordvale: product photo → particles. Runs inside a Worker started by nordvale-3d.js.
   Transparent PNGs: transparent = empty, every part is kept and the image frame sets the scale,
   so an assembled render and its exploded render line up. Photos on white: the white is dropped
   and only the product itself (largest blob) is kept. Depth comes from the silhouette (scaled by
   the per-product depth) and every dot keeps its true colour. */
window.nvPhotoKit = function photoKit() {
    function shape(px, W, H, N, cut, depth) {
      var M = new Uint8Array(W * H), i, j;
      if (cut && cut.length === 5) {                     // 5th value: fill the hidden area by mirroring across x = cut[4]
        for (var my0 = Math.floor(cut[1] * H); my0 < Math.min(H, Math.ceil(cut[3] * H)); my0++)
          for (var mx0 = Math.floor(cut[0] * W); mx0 < Math.min(W, Math.ceil(cut[2] * W)); mx0++) {
            var sx = Math.round(2 * cut[4] * W - mx0); if (sx < 0 || sx >= W) continue;
            var to = (my0 * W + mx0) * 4, fr = (my0 * W + sx) * 4;
            px[to] = px[fr]; px[to + 1] = px[fr + 1]; px[to + 2] = px[fr + 2]; px[to + 3] = px[fr + 3];
          }
        cut = null;
      }
      var clear = 0; for (i = 3; i < px.length; i += 16) if (px[i] < 128) clear++;
      var alphaMode = clear > W * H / 4 * .03;                // a real transparent background
      for (i = 0; i < W * H; i++) {
        var r = px[i * 4], g = px[i * 4 + 1], b = px[i * 4 + 2], a = px[i * 4 + 3];
        var mn = Math.min(r, g, b), mx = Math.max(r, g, b), fx = (i % W) / W, fy = ((i / W) | 0) / H;
        var hidden = cut && fx >= cut[0] && fy >= cut[1] && fx <= cut[2] && fy <= cut[3];
        M[i] = a > 128 && !hidden && (alphaMode || !(mn > 222 && mx - mn < 22)) ? 1 : 0;
      }
      var lab = new Int32Array(W * H), q = new Int32Array(W * H), best = 0, bestN = 0, id = 0, sizes = [0];
      for (i = 0; i < W * H; i++) {
        if (!M[i] || lab[i]) continue;
        id++; var h = 0, t = 0, n = 0; q[t++] = i; lab[i] = id;
        while (h < t) {
          var k = q[h++], x = k % W; n++;
          if (x > 0 && M[k - 1] && !lab[k - 1]) { lab[k - 1] = id; q[t++] = k - 1; }
          if (x < W - 1 && M[k + 1] && !lab[k + 1]) { lab[k + 1] = id; q[t++] = k + 1; }
          if (k >= W && M[k - W] && !lab[k - W]) { lab[k - W] = id; q[t++] = k - W; }
          if (k < W * (H - 1) && M[k + W] && !lab[k + W]) { lab[k + W] = id; q[t++] = k + W; }
        }
        sizes.push(n); if (n > bestN) { bestN = n; best = id; }
      }
      if (bestN < 200) return null;
      var keep = new Uint8Array(id + 1), total = 0;              // which parts to keep
      for (i = 1; i <= id; i++) if (alphaMode ? sizes[i] >= Math.max(12, bestN * .004) : i === best) { keep[i] = 1; total += sizes[i]; }
      var list = new Int32Array(total), L = 0, x0 = W, x1 = 0, y0 = H, y1 = 0;
      var rx0 = new Int32Array(H).fill(W), rx1 = new Int32Array(H).fill(-1), cy0 = new Int32Array(W).fill(H), cy1 = new Int32Array(W).fill(-1);
      for (i = 0; i < W * H; i++) if (keep[lab[i]]) {
        var xx = i % W, yy = (i / W) | 0; list[L++] = i;
        if (xx < rx0[yy]) rx0[yy] = xx; if (xx > rx1[yy]) rx1[yy] = xx; if (yy < cy0[xx]) cy0[xx] = yy; if (yy > cy1[xx]) cy1[xx] = yy;
        if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy;
      }
      var bw = x1 - x0 + 1, bh = y1 - y0 + 1, s = Math.min(3.5 / bh, 3.9 / bw), cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
      if (alphaMode) { s = Math.min(4.1 / H, 4.1 / W); cx = W / 2; cy = H / 2; }   // shared frame: assembled and exploded line up
      var thick = Math.min(bw, bh) * s * .28 * (depth > 0 ? depth : 1), pos = new Float32Array(N * 3), col = new Float32Array(N);
      for (j = 0; j < N; j++) {
        var p = list[(Math.random() * L) | 0], X = p % W, Y = (p / W) | 0;
        var ur = (X - rx0[Y] + .5) / (rx1[Y] - rx0[Y] + 1), uc = (Y - cy0[X] + .5) / (cy1[X] - cy0[X] + 1);
        var dep = Math.sqrt(Math.max(0, Math.min(Math.sin(Math.PI * ur), Math.sin(Math.PI * uc)))) * thick;
        pos[j * 3] = (X + Math.random() - cx) * s; pos[j * 3 + 1] = -(Y + Math.random() - cy) * s;
        pos[j * 3 + 2] = Math.random() < .8 ? dep : -dep * .8;
        var edge = 1 - Math.min(Math.sin(Math.PI * ur), Math.sin(Math.PI * uc)), rim = edge * edge * edge * (alphaMode ? .12 : .3);   // studio rim light
        var lift = alphaMode ? 10 : 20, kf = alphaMode ? .98 : .9, cr = px[p * 4] * kf + lift, cg = px[p * 4 + 1] * kf + lift, cb = px[p * 4 + 2] * kf + lift + 3;                // lift blacks off the background
        cr += (255 - cr) * rim; cg += (255 - cg) * rim; cb += (255 - cb) * rim;
        col[j] = Math.round(Math.min(255, cr)) * 65536 + Math.round(Math.min(255, cg)) * 256 + Math.round(Math.min(255, cb));
      }
      return { pos: pos, col: col };
    }
    function send(slot, res, kind) { if (res) postMessage({ slot: slot, kind: kind, pos: res.pos, col: res.col }, [res.pos.buffer, res.col.buffer]); else postMessage({ slot: slot, kind: kind, fail: 1 }); }
    onmessage = function (e) {
      var m = e.data;
      if (m.pixels) { send(m.slot, shape(new Uint8ClampedArray(m.pixels), m.W, m.H, m.N, m.cut, m.depth), m.kind); return; }
      fetch(m.url).then(function (r) { return r.blob(); }).then(createImageBitmap).then(function (bmp) {
        if (typeof OffscreenCanvas === 'undefined') { postMessage({ slot: m.slot, kind: m.kind, need: 1 }); return; }
        var k = Math.min(1, 360 / Math.max(bmp.width, bmp.height)), W = Math.round(bmp.width * k), H = Math.round(bmp.height * k);
        var oc = new OffscreenCanvas(W, H), x = oc.getContext('2d'); x.drawImage(bmp, 0, 0, W, H);
        send(m.slot, shape(x.getImageData(0, 0, W, H).data, W, H, m.N, m.cut, m.depth), m.kind);
      }).catch(function () { postMessage({ slot: m.slot, kind: m.kind, need: 1 }); });
    };
  };
